/* this file added by Bearer Web Developer  */
import { observer } from "mobx-react-lite";
import React, { useEffect } from 'react';
import { useAppState } from "../../../../states/app-state";
import styles from './payment.module.scss';
import { TCardInformation } from "../../../../api/bearer-api";
import getImageOfCart from "../../../price/ImageOfCard";
import { Button } from "@mui/material";
import { useThemeMode } from "../../../../states/contexts/theme"; // added by Bearer Web Developer

interface Props {
    setLoading: React.Dispatch<React.SetStateAction<boolean>>
    cardInformation: TCardInformation
}
const Payment: React.FC<Props> = observer(({ setLoading, cardInformation }) => {
    const appState = useAppState();
    const sign_up_stage = appState?.createAccount?.sign_up_stage;
    const order = appState.selectedOrder;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const handleEdit = () => {
        if (!appState.login.loggedin && sign_up_stage === 0) {
            return;
        } else {
            appState.selectedOrder?.payment?.setHasPayButton(false);
            appState.selectedOrder?.payment.setOpen(order!);
        }
    }
    const handlePay = async () => {
        // added by Bearer Web Developer start
        const order = appState.selectedOrder;
        const needToConfirmMadeOfTransport = order?.selectedTransportOption && order?.transport?.editing;
        if (needToConfirmMadeOfTransport) { // this condition added by Bearer Web Developer
            order?.ShowConfirmMadeOfTransport(); // added by Bearer Web Developer
            return;
        }
        // added by Bearer Web Developer end
        setLoading(true);
        await appState.selectedOrder?.payment.paymentAuthorization();
        setLoading(false);
    }

    useEffect(() => {
        appState.selectedOrder?.payment.selectCard(cardInformation);
    }, [])
    return (
        <div className={styles.payment} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.card}>
                <div className={styles.card_information_visa}>
                    {getImageOfCart(cardInformation)}
                </div>
                <span className={styles.text}> XXXX {cardInformation.last4}</span>
                <span className={styles.text}>{cardInformation.exp_month}/{cardInformation.exp_year}</span>
                <div onClick={handleEdit} className={styles.edit}>
                    {
                        theme === "dark" ? <img src="/edit-white.svg" alt="" width={21} height={21} /> :
                        <img src="/edit-blue.svg" alt="" width={21} height={21} />
                    }
                </div>
            </div>
            <Button className={styles.payment} onClick={handlePay} disabled={(!order?.isReadyForPayment || !order?.scheduleOrder?.scheduleOrderSetting)} // scheduleOrderSetting statement added by Bearer Web Developer
                classes={{ text: styles.payment_label }}
            >
                Pay
            </Button>

        </div>


    );
})
export default Payment;


